module.exports = __webpack_public_path__ + "img/ear01.ed5a5c8f.png";